// extracted by mini-css-extract-plugin
export default {"connectCardCol":"LoginAndSecurity_connectCardCol__gUz5v"};